import { inject, WritableSignal } from '@angular/core';
import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { COOKIES_TOKEN_SESSION_KEY } from '@lentau/auth/shared';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { isLenta } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { AppStateCacheService } from '@lentau/core/app-state-cache/shared/app-state-cache.service';
import { IS_NEW_USER_OR_BOT } from '@lentau/ui-kit/core/tokens/isNewUserOrBot';

export function checkSearchBot(browserApi: BrowserApiSupportService, window: Window & typeof globalThis): () => void {
  if (browserApi.isBrowser() && browserApi.isSearchBot()) {
    window.console.error = (): void => {};
    return () => Promise.reject();
  }
  return () => {};
}

export const setIsNewUserOrBot: () => () => void = (): (() => void) => {
  const appStateCacheService: AppStateCacheService = inject(AppStateCacheService);
  const isNewUserOrBot: WritableSignal<boolean> = inject(IS_NEW_USER_OR_BOT);

  return () => {
    const token: string | undefined = appStateCacheService.get(COOKIES_TOKEN_SESSION_KEY);
    isNewUserOrBot.set(!token);
  };
};

export const setIsHydrationStartPage: (
  isHydrationStartPage: WritableSignal<boolean>,
  document: Document
) => () => void = (isHydrationStartPage: WritableSignal<boolean>, document: Document): (() => void) => {
  return () => {
    isHydrationStartPage.set(document.URL.includes(isLenta() ? UrlsEnum.ProductPageLenta : UrlsEnum.ProductPage));
  };
};
